import React from "react";
import { obfuscateName, formatPhone } from "../../utils/dataObfuscator";

interface ConfirmDataStepProps {
  name: string;
  phone: string;
  onConfirm: () => void;
  onReject: () => void;
  isLoading: boolean;
}

export const ConfirmDataStep: React.FC<ConfirmDataStepProps> = ({
  name,
  phone,
  onConfirm,
  onReject,
  isLoading,
}) => {
  const maskedName = obfuscateName(name);
  const formattedPhone = formatPhone(phone);

  return (
    <div id="confirm-data-step" className="space-y-6">
      <div className="text-center space-y-2">
        <div className="mx-auto w-12 h-12 rounded-full bg-blue-100 flex items-center justify-center text-blue-600 mb-2">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        </div>
        <h2 className="text-2xl font-bold text-gray-900">¿Tus datos son correctos?</h2>
        <p className="text-sm text-gray-600">
          Encontramos tu información registrada. Por seguridad protegemos tu nombre.
        </p>
      </div>

      <div className="bg-gray-50 border border-gray-200 rounded-xl p-5 space-y-3">
        <div className="flex justify-between items-center py-1 border-b border-gray-200">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Nombre</span>
          <span className="text-sm font-bold text-gray-800 tracking-wide">{maskedName}</span>
        </div>
        <div className="flex justify-between items-center py-1">
          <span className="text-xs font-semibold text-gray-500 uppercase tracking-wider">Teléfono</span>
          <span className="text-sm font-semibold text-gray-700">{formattedPhone}</span>
        </div>
      </div>

      <div className="space-y-3">
        <button
          id="confirm-data-yes-btn"
          type="button"
          disabled={isLoading}
          onClick={onConfirm}
          className="w-full flex items-center justify-center py-3.5 px-4 border border-transparent rounded-lg shadow-sm text-base font-semibold text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 transition duration-150 disabled:opacity-50"
        >
          {isLoading ? (
            <span className="flex items-center space-x-2">
              <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
              </svg>
              <span>Actualizando acceso...</span>
            </span>
          ) : (
            "Sí, son mis datos"
          )}
        </button>

        <button
          id="confirm-data-no-btn"
          type="button"
          disabled={isLoading}
          onClick={onReject}
          className="w-full flex items-center justify-center py-3 px-4 border border-gray-300 rounded-lg text-sm font-semibold text-gray-700 bg-white hover:bg-gray-50 transition duration-150 disabled:opacity-50"
        >
          No, cambiar número
        </button>
      </div>
    </div>
  );
};
